<template>
    <div class="bslip-error-box">
        <div class="bslip-warning-box fadeInDown"
        v-for="(error, i) in errors"
        :key="i">
            <BetslipError :error="error" />
        </div>
    </div>
</template>

<script>
import BetslipError from './BetslipError.vue';

export default {
    name: 'BetslipErrors',
    props:
    [
        'errors',
    ],
    components:
    {
        BetslipError,
    },
};
</script>
